import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector,useDispatch } from "react-redux";
import { Grid } from "@mui/material";
import { Form } from "react-final-form";
import * as yup from "yup";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import UiInput from "../../../../../../_uiComponents/UiInput";
import UiCropFileUpload from "../../../../../../_uiComponents/common/form/UiCropFileUpload";
import {
     UiButton,
} from "../../../../../../_uiComponents/common/form/UiButton";
import Validator from "../../../../../../../_helpers/validate.schema";
import PublishedTable from "../PublishedTable";
import TermPreview from "./TermsPreview";
import { UiEditor } from "../../../../../../_uiComponents/common/form/UiStyledInputs";
import { incentiveTermContentAddRequest, incentiveTermPublishedRevisionRequest } from "../../../../../../../_redux/_actions";


const getSectionsArray = ()=>{
     let divIds = Array.from(document.querySelectorAll('[id^="termSection"]')).map(element => element.id);
     return divIds;
}

const validateSchema = () => {
     let schema = yup.object().shape({
          menuTitle: yup.string().max(50, 'tile characters are more than 50'),
          title: yup.string().max(50, 'tile characters are more than 50'),
          changeReason: yup.string().max(50, 'tile characters are more than 50'),
     });


     for (let i =  0; i <= getSectionsArray().length; i++) {

          schema = schema.shape({
               [`termTitle${i}`]: yup.string().max(50, 'tile characters are more than 50'),
               [`Description${i}`]: yup.string().max(2500, 'tile characters are more than 2500'),
             });

        }
      
        return schema;

}



const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function TermAndConditionForm(props) {

     const actionDispatch = useDispatch();
     const [initialValuesList,setInitialValuesList] = useState({});

     const { id } = useParams();
     const [termsList,setTermsList] = React.useState([]);

     useEffect(()=>{
          termsList.push({
               id:termsList.length
          });
     },[]);


     useEffect(()=>{

          // actionDispatch(
          //      incentiveTermPublishedRevisionRequest({
          //           campaignId:props.campaignId
          //      }),
          // );

     },[]);


     const { contentTermDetails,publishedData, imageUpload} = useSelector(
          (state) => {
               return {
                    publishedData:state.incentive.contentTermRevisionPublished,
                    contentTermDetails:state.incentive.contentTermDetails,
                    imageUpload:state.incentive.imageTNCUpload
               };
          },
     );


     useEffect(()=>{

          let tempObj = {};
          let rowObj = {};
          let tempArray = termsList;

          if(contentTermDetails?.MenuTitle){

               if(termsList.length>0){
                    termsList.pop();
               }
              
               tempObj.menuTitle = contentTermDetails.MenuTitle;
               tempObj.title = contentTermDetails.Title;
               tempObj.changeReason = contentTermDetails.ChangeReason ?? "";
               tempObj.bannerFileId = contentTermDetails.BannerFileId;
               tempObj.bannerImageUrl = contentTermDetails.BannerImageUrl;

               for (let index = 0; index < contentTermDetails.IncentiveCampaignContentTermsConditionItemDtos.length; index++) {
                   
                    rowObj = contentTermDetails.IncentiveCampaignContentTermsConditionItemDtos[index];

                    tempObj[`termTitle${index}`] = rowObj.title;
                    tempObj[`description${index}`] = rowObj.description;
                    tempObj[`active${index}`] = rowObj.active;

                    tempArray.push(rowObj);
                    
               }

               setTermsList(tempArray);
               setInitialValuesList(tempObj);

          }

     },[contentTermDetails]);
     

     const saveData = async (values,form) => {
        
          let finalPayload = {
               id: id,
               menuTitle: values.menuTitle,
               title: values.title,
               bannerFileId:imageUpload?.data?.data?.fileId,
               incentiveCampaignContentTermsConditionItemDtos: [],
               changeReason: values.changeReason,
               page: 1,
               pageSize: 5,
               form
          };


          let sectionArray = getSectionsArray();

          await sectionArray.forEach(e => {

               let index = e.split('termSection')[1];

               let tempArr = {
                    title:values[`termTitle${index}`],
                    description:values[`description${index}`],
                    active:values[`active${index}`],

               };


               if(values[`termTitle${index}`]!=undefined&&values[`termTitle${index}`]!=""){

                    finalPayload.incentiveCampaignContentTermsConditionItemDtos.push(tempArr);

               }
               
          });


          actionDispatch(incentiveTermContentAddRequest(finalPayload));
          setTermsList([]);
          setInitialValuesList({});
          
     }

     const submit = async () => {

          let tempList = termsList;

               tempList.push({
                    id:tempList.length
               });

          setTermsList(tempList);
          
      };

      const clearData = (index)=>{

          var element = document.getElementById("termSection"+index);
          element.parentNode.removeChild(element);
          
        
      }

     return (
          <Form
               initialValues={initialValuesList}
               onSubmit={submit}
               validate={onValidate}
               mutators={{
                    setFormAttribute: (
                         [fieldName, fieldVal],
                         state,
                         { changeValue },
                    ) => {
                         changeValue(state, fieldName, () => fieldVal);
                    },
               }}
               render={({ form, handleSubmit,values,errors}) => {
                    return (
                         <form onSubmit={validateSchema}>
                              <div className="sbm-content-section">
                                   <Grid container spacing={2} sx={{ mb: 1, mt: 1 }}>
                                        <Grid item xs={12} lg={6}>
                                             <UiInput
                                                  type="text"
                                                  label="Menu Title"
                                                  name="menuTitle"
                                             />
                                        </Grid>
                                   </Grid>
                                   <Grid container spacing={2} sx={{ mb: 1 }}>
                                        <Grid item xs={12} lg={6}>
                                             <UiInput
                                                  type="text"
                                                  label="Title"
                                                  name="title"
                                             />
                                        </Grid>
                                   </Grid>

                                   <Grid container spacing={2}>
                                        <Grid item xs={12} lg={7}>
                                             <UiCropFileUpload
                                                  defaultImage={
                                                       values.bannerImageUrl
                                                  }
                                                  setToDefault={
                                                       !contentTermDetails
                                                  }
                                                  type="termsNcondition"
                                                  aspectRatio={3.5 / 4}
                                                  minWidth="350"
                                                  label="Banner"
                                                  uploadSize="Min.image size 350px x 400px"
                                                  setUploadValue={(value) => {
                                                       form.mutators.setFormAttribute(
                                                            "bannerFileId",
                                                            value,
                                                       );
                                                  }}
                                             />
                                        </Grid>
                                   </Grid>

                                 
                                   

                                   {termsList.map((e,index)=>{
                                        return <TermPreview term={e} indexNo={index} clearDataFunc={clearData} />
                                   })}
                                   
                                   <Grid
                                        item
                                        xs={12}
                                        lg={12}
                                        sx={{ mb: 2 }}
                                   >
                                        <Stack
                                             spacing={2}
                                             direction="row"
                                             justifyContent="start"
                                             sx={{ width: "100%" }}
                                        >
                                             <Button
                                                  variant="contained"
                                                  color="success"
                                                  startIcon={
                                                       <ControlPointIcon />
                                                  }
                                                  onClick={()=>{
                                                       handleSubmit();
                                                  }}
                                             >
                                                  Add
                                             </Button>

                                        </Stack>
                                   </Grid>
                                   
                                   <Grid container spacing={2}>
                                        <Grid
                                             item
                                             xs={12}
                                             lg={6}
                                             sx={{ mt: 2 }}
                                             className='sba-campaign-content-text-bg'
                                        >
                                             <UiInput
                                                  type="text"
                                                  name="changeReason"
                                                  multiline={true}
                                                  minRows={3}
                                                  maxRows={5}
                                                  label="Change Reason"
                                             />


                                        </Grid>
                                        <Grid
                                             item
                                             xs={12}
                                             lg={12}
                                             sx={{ mb: 2, mt: 6 }}
                                        >
                                             <Stack
                                                  spacing={2}
                                                  direction="row"
                                                  justifyContent="end"
                                                  sx={{ width: "100%" }}
                                             >
                                                  <UiButton
                                                       name="Clear"
                                                       variant="outlined"
                                                       size="small"
                                                       onClick={()=>{
                                                            form.reset();
                                                            setTermsList([]);
                                                            setInitialValuesList({});
                                                       }}
                                                  />
                                                  <UiButton
                                                       name="Save"
                                                       variant="contained"
                                                       size="small"
                                                       onClick={()=>{
                                                          if(Object.keys(errors).length === 0){
                                                            saveData(values,form);
                                                          }
                                                       }}
                                                  />
                                             </Stack>
                                        </Grid>
                                        <Grid
                                             item
                                             xs={12}
                                             lg={12}

                                        >
                                             <div className="sba-revison-publish-table">
                                                  <label class="sba-content-label">Published Revision Content</label>
                                                  <PublishedTable loadData={props.loadTermRevisionData} publishedData={publishedData} />
                                             </div>
                                        </Grid>
                                   </Grid>
                              </div>
                         </form>
                    );
               }}
          />
     );
}
